<template>
  <div class="main">
    <div class="header">
      <p>
        <img src="@/assets/common/success.png" />
      </p>
      <div v-if="$route.query.isOffline">{{ $t('您已选择线下支付，') }}&nbsp;<br />{{ $t('支付成功后订单状态将会更新') }}</div>
      <div v-else>{{ $t('支付成功') }}</div>
    </div>
    <!--  线下转账信息 -->

    <div class="info" v-if="$route.query.isOffline">
      <div>
        <span>{{ $t('线下转账信息') }}</span>
        <span v-clipboard:success="showTip" v-clipboard:copy="copyValue" style="color: #72728f">
          <img src="@/assets/common/copy.png" />{{ $t('复制') }}</span
        >
      </div>
      <ul>
        <li>
          <span>{{ $t('公司名称') }}</span>
          <span>{{ $t('杭州天谷信息科技有限公司') }}</span>
        </li>
        <li>
          <span>{{ $t('税号') }}</span>
          <span>913301087458306077</span>
        </li>
        <li>
          <span>{{ $t('地址') }}</span>
          <span>{{ $t('浙江省杭州市西湖区西斗门路3号 天堂软件园D幢19层') }}</span>
        </li>
        <li>
          <span>{{ $t('电话') }}</span>
          <span>0571-88234700</span>
        </li>
        <li>
          <span>{{ $t('开户银行') }}</span>
          <span>{{ $t('平安银行杭州高新支行') }}</span>
        </li>
        <li>
          <span>{{ $t('银行账号') }}</span>
          <span>{{ transferInfo.bankAccountNo || '--' }}</span>
        </li>
      </ul>
    </div>
    <!-- 订单信息 -->

    <div class="order-info">
      <div v-for="(item, index) in invitationOrder" :key="index" class="order-item">
        <div>
          <span>{{ $t('订单ID') }}{{ item.showId }}</span>
          <span @click="item.showDetail = !item.showDetail">
            <i class="arrow-up" v-if="item.showDetail"></i>
            <i class="arrow-down" v-else></i>
          </span>
        </div>
        <div v-show="item.showDetail">
          <ul>
            <li>
              <div>{{ $t('商品名称') }}</div>
              <div>{{ item.commodityName }}</div>
            </li>
            <li>
              <div>{{ $t('订单规格') }}</div>
              <div>
                <span v-if="item.isUnLimitNum">{{ $t('无限') }}</span>
                <span v-else>{{ getShowPrice(item, 'totalNum', 'G') }} {{ getShowUnit(item) }}</span>
                <span v-show="item.paymentType === 3">{{ $t('（按量后付）') }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('有效期') }}</div>
              <div>
                {{
                  item.productType == 2
                    ? '--'
                    : item.isUnLimitTime
                    ? $t('无限')
                    : item.effectiveDate + fomrateffectiveUnit[item.effectiveUnit]
                }}
              </div>
            </li>
            <li>
              <div>{{ $t('订单成交总金额（元）') }}</div>
              <div>
                <span>{{ item.price }}</span>
                <span v-show="item.paymentType === 3">{{ $t('（已出账）') }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('已付款金额（元）') }}</div>
              <div>
                <span>{{ item.amountPaid }}</span>
              </div>
            </li>
            <li>
              <div>{{ $t('本次应支付金额（元）') }}</div>
              <div>{{ item.shoudPay }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import { mapState } from 'vuex'
import mixins from '../common'
import { Toast } from 'mint-ui'
import 'mint-ui/lib/toast/style.css'

export default {
  mixins: [mixins],

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  methods: {
    showTip() {
      Toast({
        message: $t('复制成功'),
      })
    },
    getInfo() {
      this.$ajax(this.$url.getPayInvitations(this.$route.query.invitationId), {}, false).then((res) => {
        this.invitationOrder = res.data.invitationOrder || []
        this.invitationOrder.forEach((item) => {
          this.$set(item, 'showDetail', true)
        })
      })
    },
    // 获取转账信息
    getTransferInfo() {
      this.$ajax(this.$url.getTransferInfo(this.$route.query.invitationId), {}).then((res) => {
        this.transferInfo = res.data || {}
        const bankAccountNo = res.data.bankAccountNo || '--'
        this.copyValue = `
          ${$t('公司名称：')}${$t('杭州天谷信息科技有限公司')}
          ${$t('税号：')}913301087458306077
          ${$t('地址：')}${$t('浙江省杭州市西湖区西斗门路3号天堂软件园D幢19层')}
          ${$t('电话：')}0571-88234700
          ${$t('开户银行：')}${$t('平安银行杭州高新支行')}
          ${$t('银行账号：')}${bankAccountNo}
        `
      })
    },
  },
  data() {
    return {
      invitationOrder: [],
      transferInfo: {},
      copyValue: '',
    }
  },
  created() {
    this.getInfo()
    this.getTransferInfo()
  },
}
</script>
<style lang="less" scoped>
.main {
  background: #f2f5f7;
  height: 100%;
}
.header {
  background: #fff;
  text-align: center;
  padding-top: 50px;
  font-size: 20px;
  height: 260px;
  img {
    margin-bottom: 20px;
  }
}
.info {
  margin-top: 10px;
  > div:first-child {
    padding: 0 24px;
    height: 50px;
    background: #fff;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.info ul > li {
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 10px 24px;
  align-items: center;
  span:first-child {
    width: 150px;
  }
  span:last-child {
    width: 200px;
    text-align: right;
  }
}

.order-info {
  margin-top: 15px;
  background: #fff;
}
.order-item {
  padding: 0 24px;
  border-bottom: 1px solid #d8d8d8;
  > div:first-child {
    color: #383838;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
  }
  li {
    display: flex;
    justify-content: space-between;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    > div:first-child {
      color: #4d4d4d;
    }
  }
}
.arrow-up {
  background-image: url('../../../assets/icons/up.png');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
.arrow-down {
  background-image: url('../../../assets/icons/down.png');
  width: 13px;
  height: 13px;
  background-size: cover;
  display: inline-block;
  vertical-align: middle;
}
</style>
